"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreSettings = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _reactIcons = require("@100mslive/react-icons");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _ChangeSelfRole = require("./ChangeSelfRole");
var _FullScreenItem = require("./FullScreenItem");
var _SettingsModal = _interopRequireDefault(require("../Settings/SettingsModal"));
var _RoleChangeModal = require("../RoleChangeModal");
var _ChangeNameModal = require("./ChangeNameModal");
var _StatsForNerds = require("../StatsForNerds");
var _MuteAllModal = require("./MuteAllModal");
var _FeatureFlags = require("../../services/FeatureFlags");
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _StartRecording = _interopRequireDefault(require("../Settings/StartRecording"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MoreSettings = function MoreSettings() {
  var permissions = (0, _reactSdk.useHMSStore)(_reactSdk.selectPermissions);
  var localPeerId = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerID);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showChangeNameModal = _useState4[0],
    setShowChangeNameModal = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showMuteAll = _useState6[0],
    setShowMuteAll = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showDeviceSettings = _useState8[0],
    setShowDeviceSettings = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showStatsForNerds = _useState10[0],
    setShowStatsForNerds = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showSelfRoleChange = _useState12[0],
    setShowSelfRoleChange = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showStartRecording = _useState14[0],
    setShowStartRecording = _useState14[1];
  var isMobile = (0, _reactUse.useMedia)(_reactUi.config.media.md);
  var _useRecordingStreamin = (0, _reactSdk.useRecordingStreaming)(),
    isBrowserRecordingOn = _useRecordingStreamin.isBrowserRecordingOn;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
      open: open,
      onOpenChange: setOpen,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Trigger, {
        asChild: true,
        "data-testid": "more_settings_btn",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
            title: "More options",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.VerticalMenuIcon, {})
            })
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Content, {
        sideOffset: 5,
        align: "center",
        css: {
          maxHeight: "$96",
          "@md": {
            w: "$64"
          }
        },
        children: [isMobile && permissions !== null && permissions !== void 0 && permissions.browserRecording ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
            onClick: function onClick() {
              return setShowStartRecording(function (value) {
                return !value;
              });
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.RecordIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
              variant: "sm",
              css: {
                ml: "$4"
              },
              children: [isBrowserRecordingOn ? "Stop" : "Start", " Recording"]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.ItemSeparator, {})]
        }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
          onClick: function onClick() {
            return setShowChangeNameModal(function (value) {
              return !value;
            });
          },
          "data-testid": "change_name_btn",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PencilIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            variant: "sm",
            css: {
              ml: "$4"
            },
            children: "Change Name"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChangeSelfRole.ChangeSelfRole, {
          onClick: function onClick() {
            return setShowSelfRoleChange(true);
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullScreenItem.FullScreenItem, {}), permissions.mute && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
          onClick: function onClick() {
            return setShowMuteAll(true);
          },
          "data-testid": "mute_all_btn",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.MicOffIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            variant: "sm",
            css: {
              ml: "$4"
            },
            children: "Mute All"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.ItemSeparator, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
          onClick: function onClick() {
            return setShowDeviceSettings(true);
          },
          "data-testid": "device_settings_btn",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.SettingsIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            variant: "sm",
            css: {
              ml: "$4"
            },
            children: "Settings"
          })]
        }), _FeatureFlags.FeatureFlags.enableStatsForNerds && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
          onClick: function onClick() {
            return setShowStatsForNerds(true);
          },
          "data-testid": "stats_for_nreds_btn",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.InfoIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            variant: "sm",
            css: {
              ml: "$4"
            },
            children: "Stats for Nerds"
          })]
        })]
      })]
    }), showMuteAll && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MuteAllModal.MuteAllModal, {
      onOpenChange: setShowMuteAll
    }), showChangeNameModal && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChangeNameModal.ChangeNameModal, {
      onOpenChange: setShowChangeNameModal
    }), showDeviceSettings && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SettingsModal["default"], {
      open: true,
      onOpenChange: setShowDeviceSettings
    }), _FeatureFlags.FeatureFlags.enableStatsForNerds && showStatsForNerds && /*#__PURE__*/(0, _jsxRuntime.jsx)(_StatsForNerds.StatsForNerds, {
      open: showStatsForNerds,
      onOpenChange: setShowStatsForNerds
    }), showSelfRoleChange && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RoleChangeModal.RoleChangeModal, {
      peerId: localPeerId,
      onOpenChange: setShowSelfRoleChange
    }), showStartRecording && /*#__PURE__*/(0, _jsxRuntime.jsx)(_StartRecording["default"], {
      open: showStartRecording,
      onOpenChange: setShowStartRecording
    })]
  });
};
exports.MoreSettings = MoreSettings;